'use client'

import { useSearchParams } from 'next/navigation'

import { useViewCommunityPage } from '@src/utils/analytics.util'

interface AnalyticsProps {
  deviceUUID: string | null
}

export const Analytics = ({ deviceUUID }: AnalyticsProps) => {
  const searchParams = useSearchParams()
  const slView = searchParams.get('sl-view') ?? ''
  const socialLadderPage = !!deviceUUID ? (slView !== '' ? slView : 'dashboard') : 'logged out'

  useViewCommunityPage(socialLadderPage)
  return null
}
